import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
// import { SignaturePad } from 'angular2-signaturepad';
import SignaturePad from 'signature_pad';

@Component({
    selector: 'app-signaturepad-modal',
    templateUrl: './signaturepad-modal.component.html',
    styleUrls: ['./signaturepad-modal.component.scss'],
    standalone: false
})
export class SignaturepadModalComponent implements OnInit {

  signataire;
  signature = '';
  isDrawing = false;
  @ViewChild('canvas', { static: true }) signaturePadElement;
  signaturePad: any;
  canvasWidth: number;
  canvasHeight: number;

  // @ViewChild(SignaturePad) signaturePad: SignaturePad;


  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private elementRef: ElementRef
    ) {
    this.signataire = this.navParams.get('signataire');
    const previous = this.navParams.get('signature');
    if (previous) {
      this.signature = previous;
    }
   }

  ngOnInit() {
    this.init();
  }

  drawComplete() {
    this.isDrawing = false;
  }


  ionViewDidEnter() {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.signaturePad.clear();
    this.signaturePad.penColor = 'rgb(56,128,255)';
  }

  init() {
    const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
    canvas.width = 300;
    canvas.height = 200;
    if (this.signaturePad) {
      this.signaturePad.clear(); // Clear the pad on init
    }
  }

  savePad() {
    const img = this.signaturePad.toDataURL();
    this.modalCtrl.dismiss({signature : img});
  }
 
  clearPad() {
    this.signaturePad.clear();
    // this.content = false;
  }

  undo() {
    const data = this.signaturePad.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.signaturePad.fromData(data);
    }
  }

  annuler() {
    this.modalCtrl.dismiss();
  }
}
